// Plain browser JS for toggling the full-width search bar

function initSearch() {
  var searchButtons = document.querySelectorAll(".search-modal__button");
  var closeButton = document.querySelector(".fullwidth-search-bar__close");
  var searchBar = document.getElementById("fullwidth-search-bar");
  /** @type {HTMLInputElement|null} */
  var searchInput = document.querySelector(".fullwidth-search-bar__input");
  var searchDropdown = document.getElementById("search-dropdown");
  var suggestionsList = document.getElementById("search-suggestions-list");
  var productsList = document.getElementById("search-products-list");
  var dropdownFooter = document.getElementById("search-dropdown-footer");
  var headerMain = document.getElementById("header-main-content");
  var headerComponent = document.getElementById("header-component");
  /** @type {HTMLElement|null} */ var originalDropdownParent = null;
  /** @type {Comment|null} */ var placeholderComment = null;
  /** @type {HTMLElement|null} */ var originalBarParent = null;
  /** @type {Comment|null} */ var barPlaceholder = null;
  /** @type {((this: Window, ev: Event) => any)|null} */ var boundUpdateBarMetrics = null;

  function measureHeaderHeight() {
    var h = 60;
    if (headerComponent && headerComponent.offsetHeight) {
      h = headerComponent.offsetHeight;
    } else if (headerMain && headerMain.offsetHeight) {
      h = headerMain.offsetHeight;
    }
    return h;
  }

  function updateBarMetrics() {
    if (!searchBar) return;
    var hh = measureHeaderHeight();
    searchBar.style.height = hh + 'px';
    // Pin to viewport top to match Chrome and avoid Safari sticky offsets
    searchBar.style.top = '0px';
  }

  function positionDropdown() {
    if (!searchInput || !searchDropdown) return;
    var rect = searchInput.getBoundingClientRect();
    // If input has no size yet (Safari when just mounted), retry on next frame
    if (!rect || rect.width === 0 || rect.height === 0) {
      requestAnimationFrame(positionDropdown);
      return;
    }
    // Pin the dropdown to the input: same width, no gap (overlap by 1px)
    searchDropdown.style.position = "fixed";
    searchDropdown.style.left = rect.left + "px";
    searchDropdown.style.right = "auto";
    searchDropdown.style.transform = "none";
    searchDropdown.style.width = rect.width + "px";
    searchDropdown.style.maxWidth = rect.width + "px";
    searchDropdown.style.top = rect.bottom - 1 + "px";
  }

  function mountBarToBody() {
    if (!searchBar) return;
    if (searchBar.parentElement === document.body) return;
    originalBarParent = searchBar.parentElement;
    barPlaceholder = document.createComment('fullwidth-search-bar-placeholder');
    originalBarParent && originalBarParent.insertBefore(barPlaceholder, searchBar);
    document.body.appendChild(searchBar);
    // Keep fixed at top and above everything (Safari/iOS)
    searchBar.style.zIndex = '2147483647';
    searchBar.style.left = '0';
    searchBar.style.right = '0';
  }

  function restoreBarToOriginal() {
    if (!searchBar || !originalBarParent || !barPlaceholder) return;
    originalBarParent.insertBefore(searchBar, barPlaceholder);
    originalBarParent.removeChild(barPlaceholder);
    barPlaceholder = null;
    originalBarParent = null;
    searchBar.style.zIndex = '';
    searchBar.style.left = '';
    searchBar.style.right = '';
  }

  function mountDropdownToBody() {
    if (!searchDropdown) return;
    if (searchDropdown.parentElement === document.body) return;
    // Remember original parent and position
    originalDropdownParent = searchDropdown.parentElement;
    placeholderComment = document.createComment('search-dropdown-placeholder');
    originalDropdownParent && originalDropdownParent.insertBefore(placeholderComment, searchDropdown);
    document.body.appendChild(searchDropdown);
    // Ensure on top for Safari stacking contexts
    searchDropdown.style.zIndex = '2147483647';
  }

  function restoreDropdownToOriginal() {
    if (!searchDropdown || !originalDropdownParent || !placeholderComment) return;
    originalDropdownParent.insertBefore(searchDropdown, placeholderComment);
    originalDropdownParent.removeChild(placeholderComment);
    placeholderComment = null;
    originalDropdownParent = null;
    // Clean inline styles
    searchDropdown.style.position = '';
    searchDropdown.style.left = '';
    searchDropdown.style.right = '';
    searchDropdown.style.top = '';
    searchDropdown.style.width = '';
    searchDropdown.style.maxWidth = '';
    searchDropdown.style.transform = '';
    searchDropdown.style.zIndex = '';
  }

  /**
   * Show the search dropdown with suggestions and products
   * @param {string} query
   * @param {string[]} suggestions
   * @param {{title: string, image: string, url: string}[]} products
   */
  function showDropdown(query, suggestions, products) {
    if (!searchDropdown) return;
    mountDropdownToBody();
    positionDropdown();
    
    // Check if mobile
    var isMobile = window.innerWidth <= 750;
    
    // Suggestions
    if (suggestionsList) {
      var sl = suggestionsList;
      sl.innerHTML = "";
      if (suggestions && suggestions.length > 0) {
        suggestions.forEach(function (s) {
          var li = document.createElement("li");
          var value =
            searchInput && searchInput instanceof HTMLInputElement
              ? searchInput.value.trim()
              : "";
          var idx = s.toLowerCase().indexOf(value.toLowerCase());
          
          if (value && idx !== -1) {
            // Mobile: bold the matching part, regular for the rest
            if (isMobile) {
              // Before match (regular)
              var before = document.createElement("span");
              before.style.fontWeight = "normal";
              before.textContent = s.substring(0, idx);
              // Match (bold)
              var match = document.createElement("span");
              match.style.fontWeight = "bold";
              match.textContent = s.substring(idx, idx + value.length);
              // After match (regular)
              var after = document.createElement("span");
              after.style.fontWeight = "normal";
              after.textContent = s.substring(idx + value.length);
              li.appendChild(before);
              li.appendChild(match);
              li.appendChild(after);
            } else {
              // Desktop: bold everything except match
              var before = document.createElement("span");
              before.style.fontWeight = "bold";
              before.textContent = s.substring(0, idx);
              var match = document.createElement("span");
              match.style.fontWeight = "normal";
              match.textContent = s.substring(idx, idx + value.length);
              var after = document.createElement("span");
              after.style.fontWeight = "bold";
              after.textContent = s.substring(idx + value.length);
              li.appendChild(before);
              li.appendChild(match);
              li.appendChild(after);
            }
          } else {
            li.style.fontWeight = "bold";
            li.textContent = s;
          }
          // Click: prefer navigating to a matching product page; fallback to search
          li.addEventListener("click", function () {
            try {
              /** @type {{title:string,url:string}[]|undefined} */
              var productList = (function(){
                // products variable is closed over from showDropdown arguments
                return Array.isArray(products) ? products : [];
              })();
              /** @type {(str: string) => string} */
              var normalized = function(str){ return (str || "").toString().trim().toLowerCase(); };
              var targetTitle = normalized(s);

              // 1) Exact title match
              var match = productList.find(function(p){ return normalized(p.title) === targetTitle && p.url; });
              // 2) Starts-with or contains match as fallback
              if (!match) {
                match = productList.find(function(p){
                  var pt = normalized(p.title);
                  return p.url && (pt.startsWith(targetTitle) || pt.indexOf(targetTitle) !== -1 || targetTitle.indexOf(pt) !== -1);
                });
              }
              if (match && match.url) {
                window.location.href = match.url;
              } else {
                window.location.href = "/search?q=" + encodeURIComponent(s);
              }
            } catch (e) {
              window.location.href = "/search?q=" + encodeURIComponent(s);
            }
          });
          sl.appendChild(li);
        });
      } else {
        var li = document.createElement("li");
        li.textContent = "No suggestions";
        sl.appendChild(li);
      }
    }
    // Products
    // set up an IntersectionObserver for lazy-loading images (defined once)
/** @type {IntersectionObserver|null} */
var imageObserver = null;
if ("IntersectionObserver" in window) {
  imageObserver = new IntersectionObserver(function(entries, observer) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        /** @type {HTMLImageElement} */
        var img = /** @type {HTMLImageElement} */ (entry.target);
        // set the real src from data-src
        if (img.dataset && img.dataset.src) {
          img.src = img.dataset.src;
          delete img.dataset.src;
        }
        // set srcset if available
        if (img.dataset && img.dataset.srcset) {
          img.srcset = img.dataset.srcset;
          delete img.dataset.srcset;
        }
        // stop observing this image
        observer.unobserve(img);
      }
    });
  }, {
    root: null,
    rootMargin: "100px", // preload a bit before it appears
    threshold: 0.01
  });
}

if (productsList) {
  var pl = productsList;
  pl.innerHTML = "";
  if (products && products.length > 0) {
    products.forEach(function (p) {
      var li = document.createElement("li");
      var img = document.createElement("img");

      // Use data-src for observer; set src to tiny placeholder or empty so layout is stable
      // You can replace the placeholder with a real base64 tiny image if you want a visible placeholder.
      img.dataset.src = p.image || "";
      img.alt = p.title || "";
      img.decoding = "async";
      // native lazy attribute as a fallback / extra hint
      img.loading = "lazy";

      // Mobile: smaller images, desktop: larger
      if (isMobile) {
        img.style.width = "60px";
        img.style.height = "60px";
        img.style.objectFit = "cover";
        img.style.borderRadius = "8px";
        img.style.flexShrink = "0";
      } else {
        img.style.maxWidth = "100px";
        img.style.height = "auto";
        img.style.objectFit = "contain";
      }

      // If IntersectionObserver available, observe this img. Otherwise set src now.
      if (imageObserver) {
        // set a transparent 1x1 data URI or leave empty to avoid extra requests
        img.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";
        imageObserver.observe(img);
      } else {
        // fallback: load immediately (native loading="lazy" may still help)
        img.src = p.image || "";
      }

      var span = document.createElement("span");
      span.textContent = p.title;

      // Make product clickable
      if (p.url) {
        var a = document.createElement("a");
        a.href = p.url;
        a.style.display = "flex";
        a.style.alignItems = "center";
        a.style.gap = isMobile ? "16px" : "14px";
        a.style.textDecoration = "none";
        a.style.color = "inherit";
        if (isMobile) {
          a.style.width = "100%";
        }
        a.appendChild(img);
        a.appendChild(span);
        li.appendChild(a);
      } else {
        li.appendChild(img);
        li.appendChild(span);
      }
      pl.appendChild(li);
    });
  } else {
    var li = document.createElement("li");
    li.textContent = "No products found";
    pl.appendChild(li);
  }
}

    // Footer
    if (dropdownFooter) {
      dropdownFooter.innerHTML =
        '<span style="float:left;">Search for "' +
        query +
        '"</span>' ;
      
    }
    searchDropdown.style.display = "block";
    positionDropdown();
  }

  function hideDropdown() {
    if (searchDropdown) {
      searchDropdown.style.display = "none";
    }
  }

  function ensureBarVisible() {
    if (!searchBar) return;
    // Force visible in case CSS specificity blocks it on Safari
    searchBar.style.display = 'flex';
    searchBar.style.visibility = 'visible';
    searchBar.style.opacity = '1';
  }

  function openSearch() {
    document.body.classList.add("searchbar-active");
    mountBarToBody();
    ensureBarVisible();
    // Preserve header layout and align overlay to exact header size/position
    var hh = measureHeaderHeight();
    if (headerMain) headerMain.style.minHeight = hh + 'px';
    updateBarMetrics();
    boundUpdateBarMetrics = function(){ updateBarMetrics(); };
    window.addEventListener('resize', boundUpdateBarMetrics);
    window.addEventListener('scroll', boundUpdateBarMetrics, true);
    if (searchInput && searchInput instanceof HTMLInputElement) {
      /** @type {HTMLInputElement} */
      var si = searchInput;
      // Safari sometimes needs a delayed focus
      requestAnimationFrame(function(){
        setTimeout(function(){
          try { si.focus({ preventScroll: true }); } catch (e) { si.focus(); }
          positionDropdown();
        }, 30);
      });
      // Prevent body scroll when search is active on mobile
      if (window.innerWidth <= 750) {
        document.body.style.overflow = 'hidden';
      }
    }
    // Ensure dropdown aligns to input after layout
    setTimeout(positionDropdown, 0);
  }

  function closeSearch() {
    // Hide overlay immediately to avoid visual jump above header on Safari
    if (searchBar) {
      searchBar.style.display = 'none';
    }
    document.body.classList.remove("searchbar-active");
    hideDropdown();
    restoreDropdownToOriginal();
    restoreBarToOriginal();
    if (searchBar) {
      // Keep it hidden like original markup (style="display: none;")
      searchBar.style.display = 'none';
      searchBar.style.visibility = '';
      searchBar.style.opacity = '';
      searchBar.style.height = '';
      searchBar.style.top = '';
    }
    if (headerMain) headerMain.style.minHeight = '';
    // Restore body scroll on mobile
    if (window.innerWidth <= 750) {
      document.body.style.overflow = '';
    }
    if (boundUpdateBarMetrics) {
      window.removeEventListener('resize', boundUpdateBarMetrics);
      window.removeEventListener('scroll', boundUpdateBarMetrics, true);
      boundUpdateBarMetrics = null;
    }
  }

  if (searchButtons.length > 0) {
    searchButtons.forEach(function (searchButton) {
      searchButton.addEventListener("click", function (e) {
        e.preventDefault();
        openSearch();
      });
    });
  }
  if (closeButton) {
    closeButton.addEventListener("click", function () {
      closeSearch();
    });
  }

  // Event delegation fallback (helps if elements are injected later; Safari reliability)
  document.addEventListener('click', function(e){
    var target = e.target instanceof Element ? e.target : null;
    if (!target) return;
    if (target.closest('.search-modal__button')) {
      e.preventDefault();
      openSearch();
    }
    if (target.closest('.fullwidth-search-bar__close')) {
      e.preventDefault();
      closeSearch();
    }
  }, true);

  // Close on Escape
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape') {
      closeSearch();
    }
  });
let hasLoadedInitialSuggestions = false;

// Show dropdown if input already has value (on page load/back nav)
if (searchInput && searchInput instanceof HTMLInputElement && searchInput.value.trim().length > 0) {
  var initialValue = searchInput.value.trim();
  hasLoadedInitialSuggestions = true;

  fetch(
    "/search/suggest.json?q=" +
      encodeURIComponent(initialValue) +
      "&resources[type]=product,article,page"
  )
    .then(function (res) {
      return res.json();
    })
    .then(function (data) {
      let suggestions = [];
      if (
        data.resources &&
        data.resources.results &&
        data.resources.results.queries
      ) {
        var queries = data.resources.results.queries;
        suggestions = queries.map(function(/** @type {{text:string}} */ q){ return q.text; });
      }

      let products = [];
      if (
        data.resources &&
        data.resources.results &&
        data.resources.results.products
      ) {
        var prods = data.resources.results.products;
        products = prods.map(function(/** @type {{title:string,image:string,url:string}} */ p){ return { title: p.title, image: p.image, url: p.url }; });
      }

      if (suggestions.length === 0 && products.length > 0) {
        suggestions = products.map(function(/** @type {{title:string}} */ p){ return p.title; });
      }

      showDropdown(initialValue, suggestions, products);
    })
    .catch(function () {
      showDropdown(initialValue, [], []);
    });
}

// Also show dropdown on focus if input has value AND dropdown not already triggered
    if (searchInput && searchInput instanceof HTMLInputElement) {
      searchInput.addEventListener("focus", function () {
        positionDropdown();
        /** @type {HTMLInputElement|null} */
        var si = searchInput instanceof HTMLInputElement ? searchInput : null;
        if (si && si.value.trim().length > 0 && !hasLoadedInitialSuggestions) {
          si.dispatchEvent(new Event("input"));
        }
      });

      searchInput.addEventListener("input", function (e) {
        var value = "";
        if (e.target && e.target instanceof HTMLInputElement) {
          value = e.target.value.trim();
        }
        if (value.length > 0) {
          fetch(
            "/search/suggest.json?q=" +
              encodeURIComponent(value) +
              "&resources[type]=product,article,page"
          )
            .then(function (res) {
              return res.json();
            })
            .then(function (data) {
              /** @type {string[]} */
              var suggestions = [];
              if (
                data.resources &&
                data.resources.results &&
                data.resources.results.queries
              ) {
                /** @type {{text: string}[]} */
                var queries = data.resources.results.queries;
                suggestions = queries.map(function (
                  /** @type {{text: string}} */ q
                ) {
                  return q.text;
                });
              }
              /** @type {{title: string, image: string, url: string}[]} */
              var products = [];
              if (
                data.resources &&
                data.resources.results &&
                data.resources.results.products
              ) {
                /** @type {{title: string, image: string, url: string}[]} */
                var prods = data.resources.results.products;
                products = prods.map(function (
                  /** @type {{title: string, image: string, url: string}} */ p
                ) {
                  return {
                    title: p.title,
                    image: p.image,
                    url: p.url,
                  };
                });
              }
              // Fallback: if no suggestions, use product titles
              if (suggestions.length === 0 && products.length > 0) {
                suggestions = products.map(function (/** @type {{title:string}} */ p) {
                  return p.title;
                });
              }
              showDropdown(value, suggestions, products);
            })
            .catch(function () {
              showDropdown(value, [], []);
            });
        } else {
          hideDropdown();
        }
      });
    }
    // Hide dropdown if clicking outside
    document.addEventListener("click", function (e) {
      var target = e.target;
      if (
        searchDropdown &&
        !searchDropdown.contains(target instanceof Node ? target : null) &&
        target !== searchInput
      ) {
        hideDropdown();
        restoreDropdownToOriginal();
      }
    });
    // Reposition on viewport changes and visual viewport changes (Safari)
    window.addEventListener("resize", positionDropdown);
    window.addEventListener("scroll", positionDropdown, true);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', positionDropdown);
      window.visualViewport.addEventListener('scroll', positionDropdown);
    }
  }

// Ensure initialization even if DOMContentLoaded already fired (Edge/Safari timing)
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSearch);
} else {
  initSearch();
}

// Close header account and localization dropdowns when clicking on header background
function initHeaderOutsideClose() {
  document.addEventListener('click', function(e){
    var target = e.target instanceof Element ? e.target : null;
    if (!target) return;

    // Account popover (details)
    var accountDetails = document.querySelector('details.account-popover[open]');
    if (accountDetails) {
      var summary = accountDetails.querySelector('.account-popover__summary');
      var panel = accountDetails.querySelector('.account-popover__panel');
      var clickedInsideSummary = summary ? summary.contains(target) : false;
      var clickedInsidePanel = panel ? panel.contains(target) : false;
      // If click is inside the <details> box but not on summary or panel, close it
      if (accountDetails.contains(target) && !(clickedInsideSummary || clickedInsidePanel)) {
        accountDetails.removeAttribute('open');
      }
    }

    // Localization dropdown (button + panel)
    var dropdownHost = document.querySelector('dropdown-localization-component');
    if (dropdownHost) {
      var button = dropdownHost.querySelector('.dropdown-localization__button');
      var panel = dropdownHost.querySelector('.localization-wrapper');
      var panelVisible = panel && !panel.hasAttribute('hidden');
      var clickedInsideButton = button ? button.contains(target) : false;
      var clickedInsidePanel = panel ? panel.contains(target) : false;
      // If panel is open and click is NOT on the button or panel (anywhere), hide
      if (panelVisible && !(clickedInsideButton || clickedInsidePanel)) {
        panel.setAttribute('hidden','');
        if (button) button.setAttribute('aria-expanded','false');
      }
    }
  }, true);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHeaderOutsideClose);
} else {
  initHeaderOutsideClose();
}